import React from 'react';
import GridHeader from './GridHeader';
import GridBody from './GridBody';
import './grid.scss';

const RMGrid = (props) => {
  return (
    <div className="rmb-grid">
      <GridHeader columns={props.columns} />
      <GridBody {...props} />
    </div>
  );
};

export default RMGrid;



// WEBPACK FOOTER //
// ./src/common/core/grid/RMGrid.jsx